import React, { useEffect } from 'react';
import { ItensList } from './styles';
import { Draggable } from 'react-beautiful-dnd';
import { ContainerSubItens } from '../../Components';

const ContainerItens = ({allowEdit, item, index, addComand, children, showItens, invisible, showAlarms, alarm, isNewValue}) => {
    let childs = React.Children.toArray(children);
    useEffect(() => {
        childs = React.Children.toArray(children);
    }, [item, children])

    return(
        <Draggable draggableId={item.id} index={index} key={item.id} isDragDisabled={!allowEdit}>
            {(provided, snapshot) => (
                <ItensList
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                    $isDragging={snapshot.isDragging}>

                    <ContainerSubItens isNewValue={isNewValue} item={item} allowEdit = {allowEdit} index={index} showAlarms={showAlarms}
                    addComand={(newcomand, oldValue, name, onCancel, type) => {addComand(newcomand, oldValue, name, onCancel, type)}}
                    showItens={() => showItens(item)} invisible={invisible} alarm={alarm}>
                        {childs.map(child => {
                            return child;
                        })}
                    </ContainerSubItens>
                </ItensList>
            )}
        </Draggable>
    )
}

export default ContainerItens;